import { useIntl } from "react-intl";

import { defaultHeroProps } from "./all-teams";
import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

const MarketingTabContent = () => {
    const intl = useIntl();

    const marketingHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.marketing.header",
            defaultMessage: "Unleash the power of marketing teams with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/62xi2h6p73mrb7t2ib163ss3qeh22c5f.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.marketing.heroImageAlt",
                defaultMessage:
                    "Screen capture of a Jira board tracking a marketing launch"
            })
        }
    };

    return (
        <PaidHeroTabPanelTemplate
            {...marketingHeroProps}
            {...defaultHeroProps}
        />
    );
};

export default MarketingTabContent;
